<div class="list-popup">
    <div class="header">{{ projects().length + " prosjekt" }}</div>
    <div>
        <div class="item-wrapper">
            @for(project of projects(); track $index){
            <new-dwelling-stage-item [projectStage]="project"></new-dwelling-stage-item>
            }
            <div class="bottom-margin"></div>
        </div>
    </div>
</div>
